import { ElementBaseQuickSettingRect, IQuickSettingRect } from './base';
import { IChartModel } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-model.interface';

export class ChartQuickSettingRect extends ElementBaseQuickSettingRect {
    private chartModel: IChartModel;
    public constructor(model: IChartModel) {
        super(model);
        this.chartModel = model;
    }

    public getQuickSettingRect(scale: number): IQuickSettingRect {
        const { leftOffset, topOffset } = ElementBaseQuickSettingRect.getOffset();
        const frame = this.chartModel.getFrame?.().frameOnSlide();
        return {
            x: (frame.left * scale) + leftOffset,
            y: (frame.top * scale) + topOffset,
            width: frame.width * scale,
            height: frame.height * scale,
        };
    }
}
